import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined, UserOutlined } from "@ant-design/icons";
import { Card, Flex, Select, DatePicker, Row, Col, Form, Button, Typography, Input } from "antd";
import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import { UserService } from "../../../Services/Manage/UserService";
import useMessage from "antd/es/message/useMessage";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import dayjs from "dayjs";
import AddQuotationData from "../Quotation/AddQuotationData";
import ListEqData from "../Quotation/ListEqData";
import { InvoiceService } from "../../../Services/Manage/InvoiceService";
import AddInvoiceData from "./AddInvoiceData";
import { useLocation, useNavigate } from "react-router-dom";

const { Option, OptGroup } = Select;

const ViewInvoice = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const id = location.state?.id;


    const [data, setData] = useState([]);
    const [message, msgConxt] = useMessage();
    const [eqData, setEqData] = useState([]);
    const [form] = Form.useForm();
    const [in_gen, setIn_gen] = useState([]);
    const [Eqslected, seEQSelect] = useState(true);
    const [baseData, setBasedata] = useState([]);

    const [rowData, setRowData] = useState([]);


    const getAllQotationProjects = async () => {
        try {
            const request = await QuotationService.getAllQotationProjects();
            setData(
                request.data.filter(q => q.status === 'Active' || q.status === 'active')
            );

        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        getAllQotationProjects();

        console.log(id);
        handleGetDataByQId(id);

    }, [id]);

    const Title = ({ title }) => (
        <Flex align="center" justify="space-between">
            {title}
        </Flex>
    );

    const renderItem = (eqId, name) => (
        <Flex align="center" justify="space-between" style={{ width: "100%" }}>
            <span>{eqId}</span>
            <span>
                <UserOutlined /> {name}
            </span>
        </Flex>
    );

    const grouped = data.reduce((acc, item) => {
        if (!acc[item.service_id]) {
            acc[item.service_id] = {
                service_name: item.service_name,
                items: [],
            };
        }
        acc[item.service_id].items.push(item);
        return acc;
    }, {});

    const handleGetDatabyEqid = async (value) => {
        try {
            const request = await EnquiryService.getEnquiryDetailsById(value);
            // console.log(request);

            if (request.status) {
                // message.success(request.message);
                setEqData(request.data);
                seEQSelect(true);
            } else {
                // message.success(request.message);
                console.log(request.message);
            }
            // console.log("Full option object:", option);
        } catch (error) {
            console.error(error);
        }
    }

    const handleGenerateInvoice = async () => {
        try {
            const request = await InvoiceService.getLastInvoice();
            console.log("handleGenerateInvoice", request);

            const now = new Date();
            const currentYear = String(now.getFullYear());

            let newInvoiceNo = '';

            if (request.status && request.data && request.data.invoice_no) {
                const lastInvoiceNo = request.data.invoice_no;
                const [yearPart, seqPart] = lastInvoiceNo.includes('-')
                    ? lastInvoiceNo.split('-')
                    : [lastInvoiceNo.slice(0, 2), lastInvoiceNo.slice(2)];

                const lastYear = yearPart;

                if (lastYear === currentYear) {
                    const newSeq = String(parseInt(seqPart, 10) + 1).padStart(4, '0');
                    newInvoiceNo = `${currentYear}-${newSeq}`;
                } else {
                    // New year, reset sequence
                    newInvoiceNo = `${currentYear}-0001`;
                }
            } else {
                // No last invoice or status false
                newInvoiceNo = `${currentYear}-0001`;
            }
            setIn_gen(newInvoiceNo);
            form.setFieldsValue({ invoice_no: newInvoiceNo, qu_no: id })
            return newInvoiceNo;

        } catch (error) {
            console.error(error);

            // fallback
            const now = new Date();
            const currentYear = String(now.getFullYear()).slice(-2);
            const fallbackInvoiceNo = `${currentYear}-0001`;
            console.log('Fallback invoice number:', fallbackInvoiceNo);
            return fallbackInvoiceNo;
        }
    };


    const handleGetDataByQId = async (value) => {
        try {
            await handleGenerateInvoice();
            await handleGetDatabyEqid(value);
            const request = await QuotationService.getAllQuotationById(value);
            const request_2 = await QuotationService.getEqCustomerByQId(value);

            console.log(request.data);
            console.log(request_2.data);

            setRowData(request.data.quotation_data);
            setBasedata(request.data.quotation);

            console.log(request.data.quotation);

            setEqData(request_2.data)

        } catch (error) {
            console.error(error);

        }

    }

    return (
        <>
            {msgConxt}
            <Card size="large" title={

                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <ArrowLeftOutlined
                        style={{ cursor: "pointer", fontSize: "20px" }}
                        onClick={() => window.history.back()}
                    />
                    <Typography.Title level={4} style={{ margin: 0 }}>
                        View Invoice
                    </Typography.Title>
                </div>
            }
            >
                <Form form={form} layout="vertical">
                    <Row gutter={[24, 16]}>

                        <Col xs={24} sm={8} md={8} lg={8}>
                            <Form.Item name="qu_no" label="Quotation Number" >
                                <Input size="large" disabled />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={8} md={8} lg={8}>
                            <Form.Item name='invoice_no' label="Invoice Number">
                                <Input
                                    defaultValue={in_gen}
                                    disabled
                                    size="large"
                                // type="text" is default, no need to specify
                                />


                            </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </Card>

            <Card
                style={{ marginTop: '10px', maxHeight: '370px' }}>
                <ListEqData data={eqData} />
            </Card>

            <Card
                style={{ marginTop: '10px' }}>
                <AddInvoiceData
                    Eqslected={Eqslected}
                    // data={qu_gen}
                    invoice_no={in_gen}
                    data={baseData}
                    eqData={eqData}
                    rowData={rowData}
                    baseData={baseData}
                />
            </Card>

        </>
    );
};

export default ViewInvoice;
